export default "__VITE_ASSET__DrfCWC$v__"